import React from 'react';
import { Link } from 'react-router-dom';

// Shared footer — visually identical to the homepage (NewHome.js) footer.
// Used on secondary pages (Terms, Privacy) so the whole site shares one look.
const FOOTER_STYLES = `
.wo-site-footer{background:#FFFFFF;color:#4E5B7E;padding:28px 48px;border-top:1px solid #DFE7FB;display:flex;align-items:center;justify-content:space-between;font-size:.85rem;opacity:.75;font-family:'Instrument Sans',sans-serif}
.wo-site-footer a{color:#2B5CE0}
.wo-site-footer .footer-right{display:flex;align-items:center;gap:24px}
.wo-site-footer .footer-links{display:flex;align-items:center;gap:20px}
.wo-site-footer .footer-socials{display:flex;align-items:center;gap:14px}
.wo-site-footer .footer-socials img{height:18px;width:18px}
@media (max-width:820px){
  .wo-site-footer{flex-direction:column;gap:12px;text-align:center}
  .wo-site-footer .footer-right{flex-direction:column;gap:12px}
}
`;

const SiteFooter = () => (
  <footer className="wo-site-footer">
    <style>{FOOTER_STYLES}</style>
    <span>© {new Date().getFullYear()} thewhiteowl. All rights reserved.</span>
    <span className="footer-right">
      <span className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of use</Link>
      </span>
      <span className="footer-socials">
        <a href="https://www.linkedin.com/company/whiteowlai/" target="_blank" rel="noopener noreferrer">
          <img src="/linkedin.svg" alt="LinkedIn" />
        </a>
        <a href="https://x.com/whiteowl_ai" target="_blank" rel="noopener noreferrer">
          <img src="/twitter.svg" alt="Twitter" />
        </a>
        <a href="https://www.instagram.com/thewhiteowlai/" target="_blank" rel="noopener noreferrer">
          <img src="/instagram.svg" alt="Instagram" />
        </a>
        <a href="https://www.youtube.com/@whiteowlai" target="_blank" rel="noopener noreferrer">
          <img src="/youtube.svg" alt="YouTube" />
        </a>
      </span>
    </span>
  </footer>
);

export default SiteFooter;
